// extracted by mini-css-extract-plugin
export default {"container":"AIUsageLimit__container___bML5N"};